import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  AddressBaseInterface,
  AddressBaseInterfaceWithId,
  AddressDataInterface
} from 'types';

/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import api from '../api/address.api';

export const addressesApi = createApi({
  reducerPath: 'addressesApi',
  tagTypes: ['Addresses'],
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getAddresses: builder.query<AddressDataInterface[], string>({
      queryFn: async () => {
        try {
          const { data } = await api.getAddresses();

          return { data };
        } catch (error) {
          console.error(`Error while get addresses: ${error.message}`);

          return { error: error.response?.data?.error || error.message };
        }
      },
      providesTags: ['Addresses']
    }),

    addAddress: builder.mutation({
      queryFn: async (params: AddressBaseInterface) => {
        try {
          const { data } = await api.addAddress(params);

          params.onSuccess();

          return { data };
        } catch (error) {
          console.error(`Error while add favorite location:: ${error.message}`);

          return { error: error.response?.data?.error || error.message };
        }
      },

      invalidatesTags: ['Addresses']
    }),
    updateAddress: builder.mutation({
      queryFn: async (params: AddressBaseInterfaceWithId) => {
        try {
          const { data } = await api.updateAddress(params);

          params.onSuccess();

          return { data };
        } catch (error) {
          console.error(`Error while update address: ${error.message}`);

          return { error: error.response?.data?.error || error.message };
        }
      },
      invalidatesTags: ['Addresses']
    }),
    deleteAddress: builder.mutation({
      queryFn: async ({ addressId, onSuccess }) => {
        try {
          const { data } = await api.deleteAddress(addressId);
          onSuccess();

          return { data };
        } catch (error) {
          console.error(`Error while delete address: ${error.message}`);

          return { error: error.response?.data?.error || error.message };
        }
      },
      invalidatesTags: ['Addresses']
    })
  })
});

export const {
  useGetAddressesQuery,
  useAddAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation
} = addressesApi;
